import { render, staticRenderFns } from "./UserSettingsSocialLinks.vue?vue&type=template&id=3dfba756&"
import script from "./UserSettingsSocialLinks.vue?vue&type=script&lang=js&"
export * from "./UserSettingsSocialLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports